import Page from "@/lib/components/Page";
import NavButton from "@/lib/components/NavButton";

export default function Index() {
    return (
        <Page scrollable={true}>
            <NavButton href={`/u/docs/howto`} title={"Slik bruker du Eventlista"}/>
            <NavButton href={`/u/docs/rules`} title={"Retningslinjer for bruk"}/>
            <NavButton href={`/u/docs/cookie-policy`} title={"Informasjonskapsler"}/>
            <NavButton href={`/u/docs/privacy-policy`} title={"Personvernsvilkår"}/>
            <NavButton href={`/u/docs/about`} title={"Om Eventlista"}/>
        </Page>
    )
}